import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BookingContainerGoodsModel } from '@railmybox/api-booking';

@Component({
  selector: 'rmb-copy-popup',
  templateUrl: './copy-popup.component.html',
  styleUrls: ['./copy-popup.component.scss'],
  standalone: false,
})
export class CopyPopupComponent implements OnInit {
  @Input() showAddGoodsForm: boolean;
  @Input() prefix: string;
  @Input() goodsList: number;
  @Input() good: BookingContainerGoodsModel;
  @Output() copyClicked = new EventEmitter<boolean>();
  @Output() copyAmount = new EventEmitter<{ copies: Partial<{ copies: number | null }>; good: BookingContainerGoodsModel }>();

  dropdownOpen = false;
  showError = false;

  formGroup = new FormGroup({
    copies: new FormControl<number | null>(null, [Validators.required]),
  });

  ngOnInit(): void {
    const allowedMax = 99 - this.goodsList;
    const copiesControl = this.formGroup.get('copies');
    copiesControl?.setValidators([Validators.required, Validators.max(allowedMax)]);
    this.formGroup.updateValueAndValidity();

    this.formGroup.valueChanges.subscribe(() => {
      if (this.formGroup.valid) {
        this.showError = false;
      } else {
        this.showError = true;
      }
    });
  }

  toggleDropdown() {
    this.dropdownOpen = true;
    this.copyClicked.emit(true);
  }

  onCancel() {
    this.dropdownOpen = false;
    this.copyClicked.emit(false);
  }

  onSave(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const copyGoods = {
      copies: this.formGroup.value,
      good: this.good,
    };
    this.copyAmount.emit(copyGoods);
    this.dropdownOpen = false;
  }
}
